import * as React from "react";
import type { SVGProps } from "react";
const SvgTrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="trash_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M405.333 213.333V256h213.334v-42.667A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666zM320 256v-42.667a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128V256h192a42.667 42.667 0 1 1 0 85.333h-42.667V768a170.667 170.667 0 0 1-170.666 170.667H341.333A170.667 170.667 0 0 1 170.667 768V341.333H128A42.667 42.667 0 0 1 128 256h192zm341.333 85.333H256V768a85.333 85.333 0 0 0 85.333 85.333h341.334A85.333 85.333 0 0 0 768 768V341.333H661.333zm-234.666 128A42.667 42.667 0 0 1 469.333 512v170.667a42.667 42.667 0 1 1-85.333 0V512a42.667 42.667 0 0 1 42.667-42.667zM640 512a42.667 42.667 0 1 0-85.333 0v170.667a42.667 42.667 0 1 0 85.333 0V512z"
    />
  </svg>
);
export default SvgTrashIcon;
